import { gql } from "@apollo/client"

export const ORDER_FRAGMENT = gql`
  fragment ActiveOrder on Order {
    id
    code
    state
    total
    currencyCode
    lines {
      id
      productVariant {
        id
        name
        currencyCode
      }
      unitPriceWithTax
      linePriceWithTax
      quantity
      featuredAsset {
        id
        preview
      }
    }
  }
`

export const GET_ACTIVE_ORDER = gql`
  {
    activeOrder {
      id
      ...ActiveOrder
    }
  }
  ${ORDER_FRAGMENT}
`

export const ADJUST_ITEM_QUANTITY = gql`
  mutation AdjustItemQuantity($id: ID!, $quantity: Int!) {
    adjustItemQuantity(orderLineId: $id, quantity: $quantity) {
      ... on Order {
        ...ActiveOrder
      }
      ... on ErrorResult {
        errorCode
        message
      }
    }
  }
  ${ORDER_FRAGMENT}
`

export const REMOVE_ORDER_LINE = gql`
  mutation RemoveOrderLine($id: ID!) {
    removeOrderLine(orderLineId: $id) {
      ... on Order {
        ...ActiveOrder
      }
      ... on ErrorResult {
        errorCode
        message
      }
    }
  }
  ${ORDER_FRAGMENT}
`
